angular.
module("dx.webapp.lists").
controller("DxExamlistController", function ExamlistController(
	$scope,
	$filter,

	group,
	dxLocalize
) {
	"use strict";

	var self = this;

	self.filteredExams = [];
	self.limitedExams = [];
	self.groupMap = {};

	self.searchSortState = {
		searchString: "",
		sortString: "",
	};
	self.dxLocalize = dxLocalize;

	self.examLimit = self.examLimit || 25;
	self.currentPage = 0;

	if (self.searchSortOptions) {
		self.searchSortState.sortString = self.searchSortOptions.sortOptions[0].value;
	}

	$scope.$on("DxExamsRouteController:resetSearchSortState", function resetExamListSearchSortState() {
		self.currentPage = 0;
		self.searchSortState.searchString = "";
		self.searchSortState.sortString = self.searchSortOptions.sortOptions[0].value;
	});

	self.getGroupProperty = function getGroupProperty(exam, property) { // eslint-disable-line consistent-return
		var isNotOwned = !exam.hasOwnerRights() && exam.sharedBy;
		if (exam.groupId === 0 || isNotOwned) {
			return null;
		}

		if (self.groupMap[exam.groupId]) {
			return self.groupMap[exam.groupId][property];
		}

		self.groupMap[exam.groupId] = {};
		group.get(exam.groupId).then(function onGetGroupSuccess(g) {
			self.groupMap[exam.groupId] = {
				title: g.title,
				externallyManaged: g.externallyManaged,
			};
		});
	};

	self.searchExpression = function searchExpression(exam) {
		if (!self.searchSortState.searchString) {
			return true;
		}

		var match = false;

		self.searchSortOptions.searchableProperties.forEach(function foreach(property) {
			if (match) {
				return;
			}

			var sanitizedSearchString = self.searchSortState.searchString.toLowerCase();

			switch (property) {
				case "group":
					if (self.groupMap[exam.groupId]) {
						match = self.groupMap[exam.groupId].title.toLowerCase().indexOf(sanitizedSearchString) !== -1;
					}
					break;
				case "id":
					match = exam[property].toString().toLowerCase().indexOf(sanitizedSearchString.replace(/\s+/g, "")) !== -1;
					break;
				default:
					match = exam[property].toString().toLowerCase().indexOf(sanitizedSearchString) !== -1;
			}
		});

		return match;
	};

	$scope.$watch("vm.searchSortState", function searchSortStateWatch() {
		self.currentPage = 0;
		filterExams();
	}, true);

	$scope.$watchCollection("vm.exams", function examsWatch() {
		filterExams();
	});

	$scope.$watch("vm.currentPage", function currentPageWatch() {
		filterExams();
	});

	function filterExams() {
		self.filteredExams = $filter("filter")(self.exams, self.searchExpression);

		if (typeof self.searchSortState.sortString === "string") {
			self.filteredExams = $filter("orderBy")(self.filteredExams, self.searchSortState.sortString);
		} else {
			self.filteredExams.sort(self.searchSortState.sortString);
		}

		var start = self.currentPage * self.examLimit;
		var end = start + self.examLimit;
		self.limitedFilteredExams = self.filteredExams.slice(start, end);
	}
});
